import { styled } from 'styled-components';
import moment from 'moment';

import { PAYMENT_METHOD_TO_DISPLAY } from './common';
import { PaymentConfirmedMessage } from '../../../../../../common/payment';

import billpaid from '../../../../../../assets/billpaid.png';
import MessageContent from '../../messageContent';

interface Props {
  message: PaymentConfirmedMessage;
  showTextAnimation: boolean;
}

const PaymentConfirmed: React.FC<Props> = ({ message, showTextAnimation }) => {
  return (
    <>
      <MessageContent
        content={message.answer}
        showTextAnimation={showTextAnimation}
        isAgent={'answer' in message}
        isLoading={!message.done}
      />
      <PaymentConfirmedWrapper data-test-id="payment-confirmed">
        <HeaderWrapper>
          <img src={billpaid} alt="Bill paid" />
        </HeaderWrapper>
        <PaymentDetailsWrapper>
          <DetailsHeader>Payment details</DetailsHeader>
          <DetailsContent>
            <DetailRow>
              <span>Receipt #</span>
              <span>{message.data.receipt}</span>
            </DetailRow>
            <DetailRow>
              <span>Amount paid</span>
              <span>${(message.data.amountPaid / 100).toFixed(2)}</span>
            </DetailRow>
            <DetailRow>
              <span>Date paid</span>
              <span>
                {moment(message.data.datePaid).format('MMM DD, YYYY')}
              </span>
            </DetailRow>
            <DetailRow>
              <span>Payment method</span>
              <span>{PAYMENT_METHOD_TO_DISPLAY[message.data.method]}</span>
            </DetailRow>
          </DetailsContent>
        </PaymentDetailsWrapper>
      </PaymentConfirmedWrapper>
    </>
  );
};

const PaymentConfirmedWrapper = styled.div`
  margin-top: 20px;
`;

const HeaderWrapper = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

const PaymentDetailsWrapper = styled.div`
  border: 1px solid var(--border-color);
  border-radius: 4px;
`;

const DetailsHeader = styled.div`
  background-color: var(--color-shade-30);
  font-weight: 500;
  font-size: 16px;
  padding: 10px 15px;
  border-radius: 4px 4px 0 0;
`;

const DetailsContent = styled.div`
  padding: 10px 15px;
`;

const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  border-bottom: 1px solid var(--border-color);
  padding-top: 4px;
  padding-bottom: 2px;
`;

export default PaymentConfirmed;
